import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { FilterConfig } from '../../../shared-components/panel-hub/models/filter-config';
import { AppliedFilters } from '../models/applied-filters';
import { FilterCriteria } from '../models/filter-criteria';
import { SharedModule } from '../../../shared/shared.module';
import { PanelHubConstants } from '../constants/panel-hub-constants';
import { FilterEventHub } from '../models/filter-event-hub';

@Component({
  selector: 'app-filters',
  standalone: true,
  imports: [CommonModule, FormsModule, InputTextModule, MultiSelectModule, ButtonModule, TooltipModule, SharedModule],
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss']
})
export class FiltersComponent implements OnInit {
  @Input() filterConfig: FilterConfig[] = [];
  @Input() standardFilterCount: number = PanelHubConstants.StandardFilterLength;
  @Output() filterChange = new EventEmitter<AppliedFilters>();
  @Output() filterEventHub = new EventEmitter<FilterEventHub>();
  @Output() clearAllClicked = new EventEmitter<void>();

  hasMoreThanStandardFilters: boolean = false;
  searchKey: string = '';
  showMoreFilters: boolean = false;
  selectedFilterItems: { [field: string]: any[] } = {};
  isSearchTextApplied: boolean = false;

  ngOnInit(): void {
    this.filterEventHub.emit({
      resetFilters: () => this.resetFilters(),
      clearAllFilters: () => this.clearAllFilters(),
    });
    this.initializeFilterDisplay();
  }

  onFilterChange(field: string, values: any[]) {
    this.selectedFilterItems[field] = values;
  }

  onSearch(value: string) {
    if (!value && value.length === 0 && value.trim().length === 0 && this.isSearchTextApplied) {
      this.isSearchTextApplied = false;
      this.emitFilterEvent();
    }
  }

  clearFilter(field: string) {
    this.selectedFilterItems[field] = [];
  }

  resetFilters() {
    this.searchKey = '';
    this.selectedFilterItems = {};
    this.isSearchTextApplied = false;
  }

  clearAllFilters() {
    this.resetFilters();
    this.emitFilterEvent();
    this.clearAllClicked.emit();
  }

  OnSearchEnter() {
    if (this.searchKey.trim().length >= PanelHubConstants.MinSearchTextLength) {
      this.isSearchTextApplied = true;
      this.applyFilters();
    }
  }

  applyFilters() {
    this.emitFilterEvent();
  }

  private emitFilterEvent() {
    const filters: FilterCriteria[] = Object.keys(this.selectedFilterItems)
      .filter(field => Array.isArray(this.selectedFilterItems[field])
        && this.selectedFilterItems[field].length > 0)
      .map(field => ({
        field,
        values: this.selectedFilterItems[field]
      }));

    this.filterChange.emit({
      filters,
      searchText: this.searchKey.trim().length >= PanelHubConstants.MinSearchTextLength ? this.searchKey.trim() : ''
    });
  }

  onToggleFilters(show: boolean): void {
    this.showMoreFilters = show;
  }

  initializeFilterDisplay(): void {
    this.hasMoreThanStandardFilters = this.filterConfig.length > this.standardFilterCount;
  }

}
